import { useReducer, Dispatch, Reducer } from 'react';

import produce, { Draft } from 'immer';

import { Action } from './constants';
import { StateType, ActionType } from './types';

export const initialState: StateType = {
  accounts: [],
  currentPage: 1,
  search: '',
  filters: {},
  totalCount: 0,
};

const reducer: Reducer<StateType, ActionType> = produce(
  (draft: Draft<StateType>, action: ActionType) => {
    const { type } = action;
    switch (type) {
      case Action.SET_ACCOUNTS: {
        if (!('accounts' in action)) throw new Error('Accounts is missing');
        draft.accounts = action.accounts;
        draft.totalCount = action.totalCount;
        break;
      }
      case Action.SET_PAGE: {
        if (!('page' in action)) throw new Error('Page is missing');
        const { page } = action;
        draft.currentPage = page;
        break;
      }
      case Action.SET_SEARCH: {
        if (!('search' in action)) throw new Error('Search is missing');
        const { currentPage, search } = action;
        draft.search = search;
        if (currentPage) {
          draft.currentPage = currentPage;
        }
        break;
      }
      case Action.SET_FILTERS: {
        if (!('filters' in action)) throw new Error('filters is missing');
        const { filters } = action;
        draft.filters = { ...draft.filters, ...filters };
        break;
      }
      case Action.REMOVE_FILTER: {
        if (!('key' in action)) throw new Error('Key is missing');
        const { key } = action;
        delete draft.filters[key];
        break;
      }
      default:
        throw new Error();
    }
  },
  initialState
);

export const useAccountsReducer = (): [StateType, Dispatch<ActionType>] =>
  useReducer(reducer, initialState);

export default reducer;
